import { render, staticRenderFns } from "./TableCustomSort.vue?vue&type=template&id=3fba7ceb&scoped=true"
import script from "./TableCustomSort.vue?vue&type=script&lang=js"
export * from "./TableCustomSort.vue?vue&type=script&lang=js"
import style0 from "./TableCustomSort.vue?vue&type=style&index=0&id=3fba7ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba7ceb",
  null
  
)

export default component.exports